import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.DealMarketingEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    dealMarketingEnumList: { items: data, total },
  } = await sdk.getListDealMarketingEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { dealMarketingEnum: data } = await sdk.getOneDealMarketingEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { dealMarketingEnumMany: data } = await sdk.getManyDealMarketingEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const dealMarketingEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
